module.exports = __webpack_public_path__ + "static/bill-6b0c8cf1324351553ad43d17d4b21a62.jpg";